import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { SubprocessItemRow } from "./OSSubprocessItemsTable";
import RNRazmerCellSaveMark from "./RNRazmerCellSaveMark";

interface Props {
  row: SubprocessItemRow;
  currentUserId?: string;
  isSaving?: boolean;
  onVerifyRequested: (checked: boolean) => void;
  isSaveQueued?: boolean;
}

const entityIdOf = (value?: string | { _id?: string } | null): string => {
  if (!value) return "";
  return typeof value === "object" ? (value._id || "") : value;
};

const formatDate = (value?: string): string => {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? date.format("DD.MM.YYYY") : value;
};

// Проверил: a DIFFERENT user than the operator (workedBy) ticks it; the server stamps verifiedBy*.
const RNMaterialPriemVerifyCell: React.FC<Props> = ({ row, currentUserId, isSaving, onVerifyRequested, isSaveQueued }) => {
  const { t } = useTranslation();
  const workerId = entityIdOf(row.workedBy);
  const canVerify = !!(
    row.confirmed
    && workerId
    && workerId !== currentUserId
    && (row.measuredQty || row.serialNumber || row.expiryDate || row.waste || row.rastur)
  );
  const isVerified = !!(row.verifiedByName || row.verifiedAt);
  const text = isVerified
    ? [row.verifiedByName, formatDate(row.verifiedAt)].filter(Boolean).join(" / ")
    : row.verifyRequested
      ? t('os.materialno.priemVerifyPending')
      : "";

  return (
    <td className="relative border border-gray-300 h-[26px] px-1.5 py-0.5 text-[11px] text-gray-700 bg-gray-50">
      <div className="flex items-center gap-1.5">
        <input
          type="checkbox"
          className="w-4 h-4 flex-shrink-0 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
          checked={isVerified || !!row.verifyRequested}
          disabled={!canVerify || isVerified}
          title={isVerified ? t('os.materialno.priemVerified') : t('os.materialno.priemVerifyRow')}
          onChange={(event) => onVerifyRequested(event.target.checked)}
        />
        <RNRazmerCellSaveMark status={isSaving || isSaveQueued ? "saving" : undefined} />
        <span className={row.verifyRequested && !isVerified ? "text-blue-700" : ""}>
          {text}
        </span>
      </div>
    </td>
  );
};

export default RNMaterialPriemVerifyCell;
